import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import './styles/fonts.css';
import App from './App.tsx';
import { RouterProvider } from 'react-router-dom';
import { adminRouter } from './app/admin/router';
import { AuthProvider } from './features/auth/contexts/AuthContext.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={adminRouter} />
    </AuthProvider>
  </StrictMode>,
);
